import {fetchUtils} from "$utils/fetchUtils";

export type UserPreferenceValue = Record<string, unknown>

/**
 * @example
 getUserPreference('news-badges')
 setUserPreference('news-badges', {'ai-analysis':
 {
 'clicked': true,
 'seen': 3,
 }
 })
 */

// TODO: error handling? timeouts?
// TODO: in Svelte 5, use the async fetch from the map work which also includes abortSignal handling
export async function getUserPreference<T extends UserPreferenceValue = UserPreferenceValue>(
  preferenceKey: string
): Promise<T | null> {
  try {
    const response = await fetchUtils
      .get(`/api/preference/get/${preferenceKey}`)
      .catch(fetchUtils.catchErrorAndShowNotification)

    // doHandle returns `json.data || json`.
    // - When a preference is stored: json.data is a JSON string → parse it.
    // - When nothing is stored: json.data is null, so the bare success envelope
    //   ({ success, errorCode, ... }) is returned. Detect and discard it so it
    //   never leaks into callers or back into the database.
    if (typeof response === 'string') {
      return JSON.parse(response) as T
    }
    if (response != null && !('success' in response)) {
      return response as T
    }

    // console.warn(`No user preference for ${preferenceKey}`)
  } catch (error) {
    // backend drift — e.g. no user preferences table or no entry for user
    console.warn(`Failed to fetch user preference for ${preferenceKey}`, error)
  }

  return null
}

// TODO: consider making async so that we can block
// TODO: error handling? timeouts?
// TODO: in Svelte 5, use the async fetch from the map work which also includes abortSignal handling
export function setUserPreference<T extends UserPreferenceValue = UserPreferenceValue>(
  preferenceKey: string,
  value: T
) {
  // the object needs to be wrapped in an object with {value: ...} for sirius to get the correct data
  return fetchUtils
    .post(`/api/preference/put/${preferenceKey}`, { value })
    .catch(fetchUtils.catchErrorAndShowNotification)
}